import React from 'react'
import styled, { keyframes } from 'styled-components'

const slideUp = keyframes`
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
`

const Overlay = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    display: flex;
    justify-content: center;
    padding: 16px;
    pointer-events: none;
`

const Banner = styled.div`
    pointer-events: all;
    background: #111318;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    padding: 20px 24px;
    max-width: 640px;
    width: 100%;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6);
    animation: ${slideUp} 0.35s ease;
    display: flex;
    flex-direction: column;
    gap: 14px;
`

const Text = styled.p`
    font-size: 0.82rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.72);
    margin: 0;

    a {
        color: rgba(255, 255, 255, 0.9);
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: #fff;
        }
    }
`

const ButtonRow = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`

const Btn = styled.button<{ primary?: boolean }>`
    flex: 1;
    min-width: 120px;
    padding: 10px 18px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    background: ${({ primary }) =>
        primary ? 'rgba(255,255,255,0.9)' : 'transparent'};
    color: ${({ primary }) => (primary ? '#0a0a0a' : 'rgba(255,255,255,0.8)')};

    &:hover {
        background: ${({ primary }) =>
            primary ? '#fff' : 'rgba(255,255,255,0.08)'};
        color: ${({ primary }) => (primary ? '#000' : '#fff')};
    }
`

interface Props {
    onAccept: () => void
    onReject: () => void
}

const CookieBanner: React.FC<Props> = ({ onAccept, onReject }) => {
    return (
        <Overlay role="dialog" aria-label="Cookie-Einstellungen">
            <Banner>
                <Text>
                    Wir verwenden Cookies und ähnliche Technologien, um die
                    Performance unserer Werbeanzeigen zu messen und zu
                    verbessern (Meta Pixel). Deine Daten werden dabei an Meta
                    Platforms, Inc. übertragen. Du kannst deine Einwilligung
                    jederzeit widerrufen. Weitere Informationen findest du in
                    unserem <a href="/impressum">Impressum & Datenschutz</a>.
                </Text>
                <ButtonRow>
                    <Btn primary onClick={onAccept}>
                        Alle akzeptieren
                    </Btn>
                    <Btn onClick={onReject}>Nur notwendige</Btn>
                </ButtonRow>
            </Banner>
        </Overlay>
    )
}

export default CookieBanner
